import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Chip,
} from "@mui/material";
import { Email } from "@mui/icons-material";

export default function InfoNotificationEmailOnly({ open, onClose, NotificationData }) {
  // Safety check
  if (!NotificationData) {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Emails Info List</DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3, p: 3, alignItems: "center" }}>
          {/* Notification Message */}
          <Box
            sx={{
              p: 2,
              bgcolor: "grey.900",
              color: "white",
              borderRadius: 1.5,
              borderLeft: "4px solid #1976d2", // MUI primary blue
              boxShadow: "0 2px 6px rgba(0,0,0,0.4)",
              width: "100%",
            }}
          >
            <Typography variant="body1" sx={{ fontWeight: 500 }}>
              {NotificationData.notification}
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ mt: 1, display: "block" }}
            >
              {new Date(NotificationData.time).toLocaleString()}
            </Typography>
          </Box>
          {/* Recipients Lists */}
            {/* Email Recipients */}
              <Box sx={{ width: "100%" }}>
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2, justifyContent: "center" }}
                >
                  <Email color="white" />
                  <Typography variant="h6">
                    Email Recipients ({NotificationData.emailsLength || 0})
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1, alignItems: "center", maxHeight: "50vh", overflow: "auto", pr: 1 }}>
                  {NotificationData.emailList &&
                  NotificationData.emailList.length > 0 ? (
                    NotificationData.emailList.map((email, index) => (
                      <Chip
                        key={index}
                        label={email}
                        variant="outlined"
                        color="white"
                        icon={<Email />}
                        sx={{ width: "350px", justifyContent: "flex-start" }}
                      />
                    ))
                  ) : (
                    <Typography variant="body2" color="text.secondary">
                      No email recipients
                    </Typography>
                  )}
                </Box>
              </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}